import langEn from './en'

export default [
  {
    abbr: 'en',
    value: langEn,
    label: 'English'
  }
]
